import { createCachedSelector } from 're-reselect';

import getWindowWidth from '@/state/selectors/window/get-window-width';
import { IStore } from '@/state/slices/typings';

const isCurrentWidthWiderThan = createCachedSelector(
	[getWindowWidth, (_: IStore, width: number) => width],
	(windowWidth, width) => windowWidth > width,
)((_: IStore, width: number) => String(width));

export default isCurrentWidthWiderThan;
